
<template>
  <div class="record_box">
    <div class="header_box">
      <p v-for="(item,index) in headeList"
         :key="index"
         @click="checkActive(index)"
         :class="{'active':isActive==index+1}">
        {{item}}
        <span class="line"
              v-show="isActive==index+1"></span>
      </p>
    </div>
    <div v-if="isActive==1">
      <div class="record_item"
           v-if="!isEmpty">
        <div class="box"
             v-for="(item,index) in gifts"
             :key="index+'a'">
          <div class="item"
               :class="{'item1':!item.lock}">
            <div class="info">
              <p class="title">{{item.customizeName}}</p>
              <p class="time"><img class="bj_vip"
                     :src="item.imgSmall" /></p>
            </div>
            <div class="money">
              <!-- <p @click="toPage('/vipActive/bagDetail',item.lock,item.giftId,0,item.id)"><span class="lookBag"
                      :class="{'unlook':!item.lock}">{{!item.lock?'待解锁':'查看礼包'}}</span></p> -->
              <p v-if="!item.lock"
                 @click="toPage('/vipActive/bagDetail',item.lock,item.giftId,0,item.id)"><span class="lookBag"
                      :class="{'unlook':!item.lock}">待解锁</span></p>
              <p v-else
                 @click="toNewPage(item.id)"><span class="lookBag"
                      :class="{'unlook':!item.lock}">查看礼包</span></p>
            </div>
          </div>
          <div class="pd"
               v-if="!item.lock">
            <div class="line"></div>
            <p class="look_limit">成功申请{{item.productLimit}}个贷款产品即可解锁，当前进度 <span class="limit">{{item.productNum}}/{{item.productLimit}}</span> <span class="triangle_border_right right"></span></p>
          </div>
        </div>
        <div class="box"
             v-for="(item,index) in commodities"
             :key="index+'b'"
             @click="toPage('/vipActive/couponDetail',true,item.goldCommodityId,item.expired,item.id)">
          <div class="item act_bg"
               :class="{'opacity':item.expired}">
            <div class="info">
              <p class="title">{{item.customizeName}}</p>
              <p class="time">有效期限：{{changeTime(item.endTime)}}到期</p>
            </div>
            <div class="money">
              <p><span class="red">{{item.price}}</span> <span class="redDw">元</span></p>
              <span class="allUse_icon"
                    v-if="item.expired"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="mescroll-empty"
           v-else>
        <div class="empty-tip">
          <img class="empty-img"
               src="../../assets/img/vip/card/noData.png">
          <p>空空如也~</p>
        </div>
      </div>
    </div>
    <div v-if="isActive==2">
      <MyBag></MyBag>
    </div>
  </div>
</template>

<script>
import MyBag from '../vip/myBag'
export default {
  components: {
    MyBag
  },
  data () {
    return {
      headeList: [
        '优惠券礼包', '现金券'
      ],
      isActive: 1,
      commodities: [],
      gifts: [],
      coupons: [],
      money: '',
      isEmpty: false,
    }
  },
  mounted () {
    this.isActive = this.$route.query.isActive ? this.$route.query.isActive : 1;
    if (this.isActive == 2) {
      this.util.title('现金券');
    } else {
      this.util.title('我的卡券');
    }
    this.getList();
  },
  methods: {
    checkActive (index) {
      this.isActive = index + 1;
      if (this.isActive == 2) {
        this.util.title('现金券');
        this.getList();
      } else {
        this.util.title('我的卡券');
      }
    },
    toPage (path, lock, id, expired, goldId) {
      if (lock && !expired) {
        // 进入监测页面
        this.$router.push({
          path: path,
          query: {
            id: id,
            goldId: goldId,
          }
        });
      } else if (lock == false) {
        this.$router.push({
          path: '/vipActive/highList',
          query: {
            id: id,
            goldId: goldId,
          }
        });
      }
    },
    toNewPage (id) {
      this.$router.push({
        path: "/vipActive/cardPage",
        query: { id: id },
      });
    },
    changeTime (val) {
      return val ? val.slice(0, 10) : ''
    },
    getList () {
      let _this = this;
      this.$get('/app/v1.0/memeber/getCouponsByCustomerId', {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.coupons = e.data.coupons;
            _this.commodities = e.data.commodities;
            _this.gifts = e.data.gifts;
            if (_this.commodities.length == 0 && _this.gifts.length == 0) {
              _this.isEmpty = true;
            }
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },

  }

}
</script>
<style scoped>
.record_box {
  font-family: PingFangSC-Regular;
  background: #f7f7f7;
}
.pd {
  padding: 0 0.15rem;
  color: #999;
  font-size: 0.12rem;
}
.look_limit {
  margin-top: 0.08rem;
  padding-bottom: 0.17rem;
}
.limit {
  color: #4f8cfa;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: linear-gradient(
    135deg,
    rgba(255, 172, 85, 1) 0%,
    rgba(255, 57, 31, 1) 100%
  );
  box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
  border-radius: 4px;
  margin-right: 0.05rem;
}
.list {
  float: right;
  border: 1px solid #fff;
  width: 0.8rem;
  height: 0.3rem;
  text-align: center;
  line-height: 0.3rem;
  border-radius: 15px;
  position: relative;
  top: -0.06rem;
  z-index: 11;
}

.allUse_icon {
  display: inline-block;
  width: 0.73rem;
  height: 0.73rem;
  background: url('../../assets/img/vip/allUse.png') no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-left: 0.15rem;
  border-radius: 50%;
  position: absolute;
  right: 0.19rem;
  top: 0.2rem;
  z-index: 2;
  background-color: rgba(247, 243, 241, 0.4);
}
.dw {
  font-size: 0.14rem;
  top: -0.03rem;
  font-size: 0.14rem;
  position: relative;
  left: -0.06rem;
}
.item {
  display: flex;
  flex: 1;
  justify-content: space-between;
  font-size: 0.14rem;
  font-family: PingFangSC;
  position: relative;
  padding: 0.32rem 0.27rem 0.26rem 0.15rem;
}
.item1 {
  padding-top: 0.2rem;
  padding-bottom: 0;
}
.box {
  margin-bottom: 0.15rem;
  box-shadow: 0px 2px 6px 0px rgba(210, 210, 210, 0.5);
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  /* padding-bottom: 0.3rem; */
}
.act_bg {
  background: url('../../assets/img/vip/money_bg.png') no-repeat center center;
  background-size: 100% 100%;
}
.by_vip,
.bj_vip,
.hj_vip,
.zs_vip {
  display: inline-block;
  width: 1.36rem;
  height: 0.24rem;
  /* background: url("../../assets/img/vip/card/by_vip.png") no-repeat center
    center;
  background-size: 100% 100%; */
}
.zs_vip {
  background: url('../../assets/img/vip/card/zs_vip.png') no-repeat center
    center;
  background-size: 100% 100%;
}
.hj_vip {
  background: url('../../assets/img/vip/card/hj_vip.png') no-repeat center
    center;
  background-size: 100% 100%;
}
/* .bj_vip {
  background: url("../../assets/img/vip/card/bj_vip.png") no-repeat center
    center;
  background-size: 100% 100%;
} */

.line {
  display: inline-block;
  width: 100%;
  height: 2px;
  background: url('../../assets/img/vip/card/line.png') no-repeat center center;
  background-size: 100% 100%;
}
.item .title {
  font-weight: 500;
  color: #333;
  font-size: 0.15rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 2rem;
}
.item .time {
  color: #999;
  margin-top: 0.05rem;
}
.item .gray {
  color: #666;
  font-size: 0.26rem;
  margin-right: 0.03rem;
}
.item .red {
  color: #ff514a;
  font-size: 0.26rem;
  margin-right: 0.03rem;
}
.redDw {
  color: #ff514a;
  font-size: 0.14rem;
}
.grayDw {
  color: #666;
  font-size: 0.14rem;
}
.opacity {
  opacity: 0.4;
}
.mescroll-empty {
  padding-top: 0.1rem;
  text-align: center;
}
.empty-tip {
  margin-top: 6px;
  font-size: 0.15rem;
  color: #ccc;
}
.empty-tip .empty-img {
  margin: 0 auto;
  width: 1.43rem;
  height: 1.22rem;
  margin-top: 1.14rem;
}
.record_item {
  padding: 0.15rem;
}
.lookBag,
.unlook {
  display: inline-block;
  width: 0.8rem;
  height: 0.3rem;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  border-radius: 15px;
  color: #fff;
  font-family: PingFangSC;
  font-size: 0.12rem;
  text-align: center;
  line-height: 0.3rem;
  position: relative;
  top: 0.13rem;
  right: -0.06rem;
}
.unlook {
  border-radius: 15px;
  /* opacity: 0.3; */
  border: 1px solid rgba(224, 224, 224, 1);
  color: #999999;
  background: #fff;
  position: relative;
  top: 0.16rem;
}

.header_box {
  background: #fff;
  display: flex;
  justify-content: space-between;
  font-size: 0.14rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  padding: 0.1rem 0;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
}
.line {
  display: inline-block;
  width: 28px;
  height: 2px;
  background: rgba(79, 140, 250, 1);
  border-radius: 5px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
  bottom: -0.03rem;
}
.active {
  color: #4f8cfa;
}
.header_box p {
  flex: 1;
  position: relative;
}
</style>
